module.exports = __webpack_public_path__ + "static/media/biceps.e62c221f.svg";